<template>
	<div class="content">
		<h1>Ocean Package weekly file</h1>
		<div class="margin-top border-black padding">
			<p class="black">
				Upload the weekly DSV return file (.xlsx). Every row holding an
				Ocean Package box reference (ANN-…) is recorded as an inbound
				shipment and pushed to the Ocean Package API. Boxes Ocean Package
				already accepted are skipped, so re-uploading a file only retries
				the notifications that never got through.
			</p>
			<div class="flex align-items-center margin-top">
				<input type="file" ref="file" accept=".xlsx" @change="fileSelected" />
				<button
					class="btn-md"
					:disabled="!file || uploading"
					v-on:click="upload()">
					{{ uploading ? 'Uploading...' : 'Upload' }}
				</button>
			</div>
		</div>
		<div v-if="summary" class="margin-top">
			<h2>Result</h2>
			<table>
				<tbody>
					<tr>
						<td>Rows in file</td>
						<td>{{ summary.rows }}</td>
					</tr>
					<tr>
						<td>Boxes recorded as returned</td>
						<td>{{ summary.recorded }}</td>
					</tr>
					<tr>
						<td>Retried (recorded earlier, not yet accepted)</td>
						<td>{{ summary.retried }}</td>
					</tr>
					<tr>
						<td>Notified to Ocean Package</td>
						<td>{{ summary.notified }}</td>
					</tr>
					<tr>
						<td>Already notified (skipped)</td>
						<td>{{ summary.already_notified }}</td>
					</tr>
					<tr>
						<td>No Ocean Package box on row</td>
						<td>{{ summary.no_box_reference }}</td>
					</tr>
					<tr>
						<td>Order not found</td>
						<td>{{ summary.order_not_found }}</td>
					</tr>
				</tbody>
			</table>
			<div v-if="summary.recorded + summary.retried > summary.notified" class="note small-margin-top">
				{{ summary.recorded + summary.retried - summary.notified }} recorded
				box(es) could not be pushed to Ocean Package. Re-uploading the same
				file later will retry exactly those boxes.
			</div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue'

export default {
  data: () => ({
    file: null,
    uploading: false,
    summary: null
  }),
  methods: {
    fileSelected () {
      this.file = this.$refs.file.files[0] || null
      this.summary = null
    },
    upload () {
      const formData = new FormData()
      formData.append('file', this.file)
      Vue.api.post('/ocean-package/weekly-return-file', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        before: () => this.uploading = true,
        always: () => this.uploading = false,
        callback: (response) => {
          this.summary = response
          this.file = null
          this.$refs.file.value = ''
          Vue.$ui.message('Weekly file processed')
        }
      })
    }
  },
  created () {
    Vue.$ui.setTitle('Ocean Package weekly file')
  }
}
</script>
